import React, { useEffect, useLayoutEffect, useState } from "react";
import FeatherIcon from "feather-icons-react";
import { onboardingTargetSelector } from "./onboardingRules";

const emptyRect = { top: 0, left: 0, width: 0, height: 0 };

export default function ContextualGuide({ milestone, onDismiss }) {
  const [target, setTarget] = useState(null);
  const [rect, setRect] = useState(emptyRect);
  const selector = onboardingTargetSelector(milestone?.id);

  useEffect(() => {
    if (!selector) return setTarget(null);
    let attempts = 0;
    let timeout;

    const findTarget = () => {
      const element = document.querySelector(selector);
      setTarget(element);
      if (!element && attempts++ < 12)
        timeout = window.setTimeout(findTarget, 150);
    };
    findTarget();
    return () => window.clearTimeout(timeout);
  }, [selector]);

  useLayoutEffect(() => {
    if (!target) return undefined;

    const update = () => setRect(target.getBoundingClientRect());
    update();
    window.addEventListener("resize", update);
    window.addEventListener("scroll", update, true);
    return () => {
      window.removeEventListener("resize", update);
      window.removeEventListener("scroll", update, true);
    };
  }, [target]);

  if (!milestone) return null;

  const activate = () => {
    target?.focus?.();
    target?.click?.();
  };
  const actionable = target?.matches?.('button,a,input,[role="button"]');
  return (
    <>
      {target && (
        <div
          className="contextual-guide__spotlight"
          aria-hidden="true"
          style={{
            top: rect.top - 6,
            left: rect.left - 6,
            width: rect.width + 12,
            height: rect.height + 12,
          }}
        />
      )}
      <aside
        className="contextual-guide"
        aria-label="PIERS contextual guidance"
      >
        <button
          type="button"
          className="contextual-guide__close"
          onClick={onDismiss}
          aria-label="Skip guidance"
        >
          <FeatherIcon icon="x" />
        </button>
        <p className="contextual-guide__eyebrow">PIERS GUIDE</p>
        <h2>{milestone.title}</h2>
        <p>{milestone.description}</p>
        {milestone.detail && <small>{milestone.detail}</small>}
        <div className="contextual-guide__actions">
          {actionable && (
            <button
              type="button"
              className="contextual-guide__primary"
              onClick={activate}
            >
              {milestone.action?.label || "Continue"}
              <FeatherIcon icon="arrow-right" />
            </button>
          )}
          <button type="button" onClick={onDismiss}>
            Skip guidance
          </button>
        </div>
      </aside>
    </>
  );
}

export function CompletionToast({
  milestone,
  nextAction,
  onContinue,
  onDismiss,
}) {
  return (
    <aside className="onboarding-completion-toast" role="status">
      <span>
        <FeatherIcon icon="check" />
      </span>
      <div>
        <strong>{milestone?.title || "Milestone"} completed</strong>
        <p>Your saved PIERS data updated the setup checklist.</p>
      </div>
      {nextAction && (
        <button type="button" onClick={onContinue}>
          Next: {nextAction.label}
          <FeatherIcon icon="arrow-right" />
        </button>
      )}
      <button
        type="button"
        className="onboarding-completion-toast__close"
        onClick={onDismiss}
        aria-label="Dismiss completion message"
      >
        <FeatherIcon icon="x" />
      </button>
    </aside>
  );
}
